import { useContext, useEffect, useState } from 'react';
import { DateFieldFormik, TextFieldFormik } from '@components/general/formikFields';
import { UserIdentityContext } from '@context';
import { UserIdentityType } from '@types';
import { mapStringDefault } from '@utils';
import { Form, Formik, FormikProps } from 'formik';

// Styles
import styles from './userAccountIdentity.module.scss';

export const UserAccountIdentityDetails = () => {
	// Context
	const { userIdentity } = useContext(UserIdentityContext);

	// State;
	const [identityDetailsInitialValues, setIdentityDetailsInitialValues] = useState<
		Partial<UserIdentityType>
	>(mapUserIdentityToFormValues());

	function mapUserIdentityToFormValues(userIdentity?: UserIdentityType): Partial<UserIdentityType> {
		return {
			firstName: mapStringDefault(userIdentity?.firstName),
			lastName: mapStringDefault(userIdentity?.lastName),
			email: mapStringDefault(userIdentity?.email),
			birthdate: mapStringDefault(userIdentity?.birthdate),
		};
	}

	useEffect(() => {
		setIdentityDetailsInitialValues(mapUserIdentityToFormValues(userIdentity));
	}, [userIdentity]);

	const IdentityDetailsForm = () => (
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		<Formik initialValues={identityDetailsInitialValues} onSubmit={() => {}}>
			{({}: FormikProps<Partial<UserIdentityType>>, isDisabled = true) => (
				<Form>
					<div className={styles['form--double-grid']}>
						<div className={styles['grid__col']}>
							<>
								<label>First name:</label>
								<TextFieldFormik
									props={{
										name: 'firstName',
										placeholder: 'E.g. Mark',
										disabled: isDisabled,
									}}
								/>
								<p></p>
							</>
							<>
								<label>Last name:</label>
								<TextFieldFormik
									props={{
										name: 'lastName',
										placeholder: 'E.g. Scott',
										disabled: isDisabled,
									}}
								/>
								<p></p>
							</>
						</div>
						<div className={styles['grid__col']}>
							<>
								<label>Login email:</label>
								<TextFieldFormik
									props={{
										name: 'email',
										disabled: isDisabled,
									}}
									testId="identityEmail"
								/>
								<p></p>
							</>
							<>
								<label>Date of birth:</label>
								<DateFieldFormik
									props={{
										name: 'birthdate',
										disabled: isDisabled,
									}}
								/>
								<p></p>
							</>
						</div>
					</div>
				</Form>
			)}
		</Formik>
	);

	return <IdentityDetailsForm />;
};
